import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=326a6e5c&"
import script from "./AccountPage.vue?vue&type=script&lang=js&"
export * from "./AccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports